export var getSlides = function (arr, size) {
    if (!arr || !size)
        return [];
    return Array.from({ length: Math.ceil(arr.length / size) }, function (v, i) { return arr.slice(i * size, i * size + size); });
};
export var getWindowSize = function (width, breakpoints) {
    var breakpoint = {
        width: width,
        items: 1
    };
    Object.values(breakpoints)
        .sort(function (a, b) { return b.width - a.width; })
        .every(function (b) {
        if (width >= b.width) {
            breakpoint = b;
            return false;
        }
        return true;
    });
    return breakpoint;
};
//# sourceMappingURL=FeedCarousel.utilities.js.map